//import Spline from '@splinetool/react-spline';
import './App.css';

function App() {
  console.log("Hello world");
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        src="https://my.spline.design/progetto1-290a6f51c7a749ccfa668d43d26a0f8d/"
        style={{ width: '100%', height: '100%' }}
        allowFullScreen
        title='Solar systems'
      ></iframe>    </div>
  );
}

export default App;
